const whitespacesRegex = /^\s*$/;

const isNullOrWhiteSpace = value => !value || !!value.match(whitespacesRegex);

export default isNullOrWhiteSpace;
